import store from '@/state/store'

export default [
  {
    path: '',
    name: 'home',
    meta: { authRequired: true },
    component: () => import('./view/home/welcome.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { authRequired: true },
    component: () => import('./view/admin/dashboard.vue'),
  },
  {
    path: '/companies',
    name: 'company',
    meta: { authRequired: true },
    component: () => import('./view/admin/companies.vue'),
  },
  {
    path: '/bank',
    name: 'bank',
    meta: { authRequired: true },
    component: () => import('./view/bank/bank.vue'),
  },
  {
    path: '/ats-dashboard',
    name: 'ats-dashboard',
    meta: { authRequired: true },
    component: () => import('./view/ats/ats-dashboard'),
  },
  {
    path: '/global-interviews',
    name: 'global-interviews',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/global-interviews'),
  },
  {
    path: '/interview-types-create/',
    name: 'interview-types-create',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-types-create'),
  },
  {
    path: '/interview-types-modify/:id',
    name: 'interview-types-modify',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-types-create'),
  },
  {
    path: '/questionnaire-steps-create/:id',
    name: 'questionnaire-steps-create',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/questionnaire-steps-create'),
  },
  {
    path: '/create-question-interview-types/:id',
    name: 'create-question-interview-types',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/create-question-interview-types'),
  },

  {
    path: '/create-response-interview-types/:id',
    name: 'create-response-interview-types',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/create-response-interview-types'),
  },
  {
    path: '/edit-interview-campaign/:id',
    name: 'edit-interview-campaign',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/create-response-interview-types'),
  },
  {
    path: '/interview-campaigns-create',
    name: 'interview-campaigns-create',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-campaigns-create'),
  },
  {
    path: '/interview-campaigns-modify/:id',
    name: 'interview-campaigns-modify',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-campaigns-create'),
  },
  {
    path: '/interview-person-concern-create/:id',
    name: 'interview-person-concern-create',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-person-concern-create'),
  },
  {
    path: '/interviews-planning/:id',
    name: 'interviews-planning',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interviews-planning'),
  },
  {
    path: '/interview-campaigns-profile/:id',
    name: 'interview-campaigns-profile',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interview-campaigns-profile'),
  },
  {
    path: '/interviews-profile/:id',
    name: 'interviews-profile',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/interviews-profile'),
  },
  {
    path: '/pays',
    name: 'pays',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/pays'),
  },
  {
    path: '/folders',
    name: 'folders',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/folders'),
  },
  {
    path: '/shared-documents',
    name: 'shared-documents',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/shared-documents'),
  },
  {
    path: '/payslips',
    name: 'payslips',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/payslips'),
  },
  {
    path: '/timingsheet',
    name: 'timingsheet',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/timingsheet'),
  },
  {
    path: '/time-sheet-teams',
    name: 'time-sheet-teams',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/time-sheet-teams'),
  },
  {
    path: '/time-sheet-team/:id',
    name: 'time-sheet-team',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/time-sheet-team'),
  },
  {
    path: '/absence-params',
    name: 'absence-params',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/absence-params'),
  },
  {
    path: '/my-absences',
    name: 'my-absences',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/absences/my-absences'),
  },
  {
    path: '/team-absences',
    name: 'team-absences',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/absences/team-absences'),
  },
  {
    path: '/absences-overviews',
    name: 'absences-overviews',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/absences/absences-overview'),
  },
  {
    path: '/absence-requests',
    name: 'absence-requests',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/absences/absence-request'),
  },
  {
    path: '/catalogue-formation',
    name: 'catalogue-formation',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/catalogue-formation'),
  },
  {
    path: '/my-formations',
    name: 'my-formations',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/my-formations'),
  },
  {
    path: '/create-catalogue-formation',
    name: 'create-catalogue-formation',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/create-catalogue-formation'),
  },
  {
    path: '/schedule-templates',
    name: 'schedule-templates',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/schedule-templates'),
  },
  {
    path: '/expenses-report',
    name: 'expense-report',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/expense-reports'),
  },
  {
    path: '/expense-report-detail/:id',
    name: 'expense-report-detail',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/expense-report/expense-report-detail'),
  },
  {
    path: '/companies',
    name: 'companies',
    component: () => import('./view/company/create'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/getApplicationSuccess']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/personel',
    name: 'personel',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/personel'),
  },
  {
    path: '/onboarding-pipelines',
    name: 'onboarding-pipelines',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-pipelines.vue'),
  },
  {
    path: '/onboarding-dashboard',
    name: 'onboarding-dashboard',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-dashboard.vue'),
  },
  {
    path: '/onboarding/:id',
    name: 'onboarding',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding.vue'),
    props: true,
  },
  {
    path: '/my-onboarding/:id',
    name: 'my-onboarding',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/my-onboarding.vue'),
    props: true,
  },
  {
    path: '/my-onboardings',
    name: 'my-onboardings',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/my-onboardings.vue'),
    props: true,
  },
  {
    path: '/onboarding-pipeline/:id',
    name: 'onboarding-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-pipeline.vue'),
    props: true,
  },
  {
    path: '/onboarding-pipeline-tasks/:id/role/:role',
    name: 'onboarding-pipeline-tasks',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-pipeline-tasks.vue'),
    props: true,
  },
  {
    path: '/onboarding-pipeline-home/:id',
    name: 'onboarding-pipeline-home',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-pipeline-home.vue'),
    props: true,
  },
  {
    path: '/onboarding-create-pipeline',
    name: 'onboarding-create-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-create-pipeline'),
    props: (route) => ({ type: route.query.type }),
  },
  {
    path: '/onboarding-modify-pipeline/:id',
    name: 'onboarding-modify-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/onboarding-modify-pipeline'),
    props: true,
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { authRequired: true },
    component: () => import('./view/profile/profile-base'),
    props: (route) => ({ newHire: route.query.newHire }),
  },
  {
    path: '/synchro',
    name: 'synchro',
    meta: { authRequired: true },
    component: () => import('./view/profile/synchro.vue'),
  },
  {
    path: '/bridge-connect-redirection/:status',
    name: 'bridge-connect-redirection',
    meta: { authRequired: true },
    component: () => import('./view/profile/bridge-connect-redirection.vue'),
    props: (route) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/projects',
    name: 'projects',
    meta: { authRequired: true },
    component: () => import('./view/projects/projects'),
  },
  {
    path: '/reports',
    name: 'reports',
    meta: { authRequired: true },
    component: () => import('./view/projects/reports'),
  },
  {
    path: '/workload',
    name: 'workload',
    meta: { authRequired: true },
    component: () => import('./view/projects/workload'),
  },
  {
    path: '/topics',
    name: 'topics',
    meta: { authRequired: true },
    component: () => import('./view/projects/topics'),
  },
  {
    path: '/topic/:id',
    name: 'topic',
    meta: { authRequired: true },
    component: () => import('./view/projects/topic'),
  },
  {
    path: '/tasks',
    name: 'tasks',
    meta: { authRequired: true },
    component: () => import('./view/projects/tasks'),
  },
  {
    path: '/project/:id',
    name: 'project',
    meta: { authRequired: true },
    component: () => import('./view/projects/project'),
  },
  {
    path: '/prices',
    name: 'prices',
    meta: { authRequired: true },
    component: () => import('./view/products/prices'),
  },
  {
    path: '/services',
    name: 'services',
    meta: { authRequired: true },
    component: () => import('./view/products/services'),
  },
  {
    path: '/categories',
    name: 'categories',
    meta: { authRequired: true },
    component: () => import('./view/products/categories'),
  },
  {
    path: '/product-create-stocks/:id',
    name: 'product-create-stocks',
    meta: { authRequired: true },
    component: () => import('./view/products/product-create-stocks'),
  },
  {
    path: '/product-create-specs/:id',
    name: 'product-create-specs',
    meta: { authRequired: true },
    component: () => import('./view/products/product-create-specs'),
  },
  {
    path: '/product-create',
    name: 'product-create',
    meta: { authRequired: true },
    component: () => import('./view/products/product-create'),
  },
  {
    path: '/product-modify/:id',
    name: 'product-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/product-create'),
  },
  {
    path: '/products',
    name: 'products',
    meta: { authRequired: true },
    component: () => import('./view/products/products'),
  },
  {
    path: '/product-detail/:id',
    name: 'product-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/product-detail'),
  },
  {
    path: '/product-params',
    name: 'product-params',
    meta: { authRequired: true },
    component: () => import('./view/products/product-params'),
  },
  {
    path: '/stock-updates',
    name: 'stock-updates',
    meta: { authRequired: true },
    component: () => import('./view/products/stock-updates'),
  },
  {
    path: '/stock-update/:id/:type',
    name: 'stock-update',
    meta: { authRequired: true },
    component: () => import('./view/products/stock-update'),
  },
  {
    path: '/stock-update-create/:type',
    name: 'stock-update-create',
    meta: { authRequired: true },
    component: () => import('./view/products/stock-update-create'),
  },
  {
    path: '/stock-update-modify/:id/:type',
    name: 'stock-update-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/stock-update-create'),
  },
  {
    path: '/movements',
    name: 'movements',
    meta: { authRequired: true },
    component: () => import('./view/products/movements'),
  },
  {
    path: '/movements-create',
    name: 'movements-create',
    meta: { authRequired: true },
    component: () => import('./view/products/movements-create'),
  },
  {
    path: '/movements-create/:order',
    name: 'movements-order-create',
    meta: { authRequired: true },
    component: () => import('./view/products/movements-create'),
  },
  {
    path: '/movements-modify/:id',
    name: 'movements-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/movements-create'),
  },
  {
    path: '/movements/:id',
    name: 'movements-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/movements-detail'),
  },

  {
    path: '/stockageareas',
    name: 'stockageareas',
    meta: { authRequired: true },
    component: () => import('./view/products/stockage-area'),
  },
  {
    path: '/productbatches',
    name: 'productbatches',
    meta: { authRequired: true },
    component: () => import('./view/products/product-batches'),
  },
  {
    path: '/order-return/:id',
    name: 'order-return-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/order-return-detail'),
  },
  {
    path: '/order-return-create/:order',
    name: 'order-return-create',
    meta: { authRequired: true },
    component: () => import('./view/products/order-return-create'),
  },
  {
    path: '/order-return-modify/:id',
    name: 'order-return-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/order-return-create'),
  },
  {
    path: '/order-returns',
    name: 'orderreturns',
    meta: { authRequired: true },
    component: () => import('./view/products/order-return'),
  },
  {
    path: '/order/:id',
    name: 'order-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/order-detail'),
  },
  {
    path: '/order-create/:id',
    name: 'order-create-products',
    meta: { authRequired: true },
    component: () => import('./view/products/order-create-products'),
  },
  {
    path: '/order-create',
    name: 'order-create',
    meta: { authRequired: true },
    component: () => import('./view/products/order-create'),
  },
  {
    path: '/order-modify/:id',
    name: 'order-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/order-create'),
  },
  {
    path: '/order',
    name: 'order',
    meta: { authRequired: true },
    component: () => import('./view/products/order'),
  },
  {
    path: '/status-stock',
    name: 'status-stock',
    meta: { authRequired: true },
    component: () => import('./view/products/status-stock'),
  },
  {
    path: '/orders',
    name: 'orders',
    meta: { authRequired: true },
    component: () => import('./view/commercial/orders'),
  },
  {
    path: '/agenda',
    name: 'agenda',
    meta: { authRequired: true },
    component: () => import('./view/commercial/agenda'),
  },
  {
    path: '/clients',
    name: 'clients',
    meta: { authRequired: true },
    component: () => import('./view/commercial/clients'),
  },
  {
    path: '/directory',
    name: 'directory',
    meta: { authRequired: true },
    component: () => import('./view/commercial/directory'),
  },
  {
    path: '/contact/:id',
    name: 'contact',
    meta: { authRequired: true },
    component: () => import('./view/commercial/contact'),
  },

  {
    path: '/organization/:id',
    name: 'organization',
    meta: { authRequired: true },
    component: () => import('./view/commercial/organization'),
  },

  {
    path: '/price-levels',
    name: 'price-levels',
    meta: { authRequired: true },
    component: () => import('./view/commercial/price-levels'),
  },

  {
    path: '/taxes',
    name: 'taxes',
    meta: { authRequired: true },
    component: () => import('./view/commercial/taxes'),
  },

  {
    path: '/business-management/',
    name: 'business-management',
    meta: { authRequired: true },
    component: () => import('./view/commercial/business-management'),
  },

  {
    path: '/opportunities/:id',
    name: 'opportunities',
    meta: { authRequired: true },
    component: () => import('./view/commercial/opportunities'),
  },

  {
    path: '/pipelines',
    name: 'pipelines',
    meta: { authRequired: true },
    component: () => import('./view/commercial/pipelines'),
  },

  {
    path: '/opportunity/:id',
    name: 'opportunity',
    meta: { authRequired: true },
    component: () => import('./view/commercial/opportunity'),
  },

  {
    path: '/pipeline-create',
    name: 'pipeline-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/pipeline-create'),
  },

  {
    path: '/pipeline-modify/:id',
    name: 'pipeline-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/pipeline-modify'),
  },

  {
    path: '/quotation/:id/:sales',
    name: 'quotation',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotation'),
    beforeEnter: (to, from, next) => {
      next()
    },
  },

  {
    path: '/quotation-public/:company/:id/:sales/',
    name: 'quotation-public',
    meta: { authRequired: false },
    component: () => import('./view/commercial/quotation/quotation-public'),
  },

  {
    path: '/quotations/:sales',
    name: 'quotations',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotations'),
  },
  {
    path: '/quotation-create/:sales',
    name: 'quotation-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotation-create'),
  },
  {
    path: '/quotation-modify/:id/:sales',
    name: 'quotation-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotation-create'),
  },
  {
    path: '/quotation-create-organization/:id/:sales',
    name: 'quotation-create-organization',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotation-create-organization'),
  },
  {
    path: '/quotation-create-product/:id/:sales',
    name: 'quotation-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/quotation/quotation-create-product'),
  },
  {
    path: '/purchase-order-create/:sales',
    name: 'purchase-order-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/purchase-order/purchase-order-create'),
  },
  {
    path: '/purchase-order-modify/:id/:sales',
    name: 'purchase-order-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/purchase-order/purchase-order-create'),
  },
  {
    path: '/purchase-order-create-product/:id/:sales',
    name: 'purchase-order-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/purchase-order/purchase-order-product'),
  },
  {
    path: '/purchase-orders/:sales',
    name: 'purchase-orders',
    meta: { authRequired: true },
    component: () => import('./view/commercial/purchase-order/purchase-orders'),
  },
  {
    path: '/purchase-order/:id/:sales',
    name: 'purchase-order',
    meta: { authRequired: true },
    component: () => import('./view/commercial/purchase-order/purchase-order'),
  },
  {
    path: '/purchase-order-public/:company/:id/:sales/',
    name: 'purchase-order-public',
    meta: { authRequired: false },
    component: () => import('./view/commercial/purchase-order/purchase-order-public'),
  },

  {
    path: '/personal-organizations',
    name: 'personal-organizations',
    meta: { authRequired: true },
    component: () => import('./view/commercial/personal-organizations'),
  },
  {
    path: '/credits/:sales',
    name: 'credits',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credits'),
  },
  {
    path: '/credit/:id/:sales',
    name: 'credit',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credit'),
  },
  {
    path: '/credit-public/:company/:id/:sales/',
    name: 'credit-public',
    meta: { authRequired: false },
    component: () => import('./view/commercial/credit/credit-public'),
  },
  {
    path: '/credit-modify/:id/:sales',
    name: 'credit-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credit-create'),
  },
  {
    path: '/credit-create/:sales',
    name: 'credit-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credit-create'),
  },
  {
    path: '/credit-create-organization/:id/:expense',
    name: 'credit-create-organization',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credit-create-organization'),
  },
  {
    path: '/credit-create-product/:id/:sales',
    name: 'credit-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/credit/credit-create-product'),
  },
  {
    path: '/invoice-public/:company/:id/:sales/',
    name: 'invoice-public',
    meta: { authRequired: false },
    component: () => import('./view/commercial/invoice/invoice-public'),
  },
  {
    path: '/invoice/:id/:sales',
    name: 'invoice',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice'),
  },
  {
    path: '/invoice-payment/:id/',
    name: 'invoice-payment',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-payment'),
    props: true,
  },
  {
    path: '/invoice-payment-bulk/:id',
    name: 'invoice-payment-bulk',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-payment-bulk'),
    props: true,
  },
  {
    path: '/feedbacks',
    name: 'feedbacks',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedbacks'),
  },
  {
    path: '/feedback-templates',
    name: 'feedback-templates',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-templates'),
  },
  {
    path: '/feedback-template/:id',
    name: 'feedback-template',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-template'),
  },
  {
    path: '/feedback-create-template',
    name: 'feedback-create-template',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-create-template'),
  },
  {
    path: '/feedback-modify-template/:id',
    name: 'feedback-modify-template',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-create-template'),
  },
  {
    path: '/feedback-create-questions/:id',
    name: 'feedback-create-questions',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-create-questions'),
  },
  {
    path: '/feedback-add-steps/:id',
    name: 'feedback-add-steps',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-add-steps'),
  },
  {
    path: '/feedback-answer/:id',
    name: 'feedback-answer',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback-answer'),
  },
  {
    path: '/feedback-detail/:id',
    name: 'feedback-detail',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/feedback'),
  },

  {
    path: '/invoice-payment-public/:company/:id/',
    name: 'invoice-payment-public',
    meta: { authRequired: false },
    component: () => import('./view/commercial/invoice/invoice-payment'),
    props: true,
  },
  {
    path: '/invoice-payment-redirection/:status',
    name: 'invoice-payment-redirection',
    component: () => import('./view/commercial/invoice/invoice-payment-redirection'),
    meta: { authRequired: true },
    props: (route) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/invoices/:sales',
    name: 'invoices',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoices'),
  },
  {
    path: '/invoice-create/:sales',
    name: 'invoice-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-create'),
  },
  {
    path: '/invoice-modify/:sales/:id',
    name: 'invoice-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-create'),
  },
  {
    path: '/invoice-create-product/:id/:sales',
    name: 'invoice-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-create-product'),
  },
  {
    path: '/delivery-note/:id/:sales',
    name: 'delivery-note',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-note'),
  },
  {
    path: '/delivery-note-public/:company/:id/:sales/',
    name: 'delivery-note-public',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-note-public'),
  },
  {
    path: '/delivery-notes/:sales',
    name: 'delivery-notes',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-notes'),
  },
  {
    path: '/delivery-note-create/:sales',
    name: 'delivery-note-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-note-create'),
  },
  {
    path: '/delivery-note-modify/:id/:sales',
    name: 'delivery-note-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-note-create'),
  },
  {
    path: '/delivery-note-create-product/:id/:sales',
    name: 'delivery-note-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/delivery-note/delivery-note-create-product'),
  },
  {
    path: '/refund/:id/:sales',
    name: 'refund',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refund'),
  },
  {
    path: '/refund-public/:company/:id/:sales/',
    name: 'refund-public',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refund-public'),
  },
  {
    path: '/refunds/:sales',
    name: 'refunds',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refunds'),
  },
  {
    path: '/refund-create/:sales',
    name: 'refund-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refund-create'),
  },
  {
    path: '/refund-modify/:id/:sales',
    name: 'refund-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refund-create'),
  },
  {
    path: '/refund-create-product/:id/:sales',
    name: 'refund-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/refund/refund-create-product'),
  },
  {
    path: '/product-return/:id/:sales',
    name: 'product-return',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-return'),
  },
  {
    path: '/product-return-public/:company/:id/:sales/',
    name: 'product-return-public',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-return-public'),
  },
  {
    path: '/product-returns/:sales',
    name: 'product-returns',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-returns'),
  },
  {
    path: '/product-return-create/:sales',
    name: 'product-return-create',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-return-create'),
  },
  {
    path: '/product-return-modify/:id/:sales',
    name: 'product-return-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-return-create'),
  },
  {
    path: '/product-return-create-product/:id/:sales',
    name: 'product-return-create-product',
    meta: { authRequired: true },
    component: () => import('./view/commercial/product-return/product-return-create-product'),
  },
  {
    path: '/invoice-modify/:id/:sales',
    name: 'invoice-modify',
    meta: { authRequired: true },
    component: () => import('./view/commercial/invoice/invoice-modify'),
  },

  {
    path: '/crm-reporting',
    name: 'crm-reporting',
    meta: { authRequired: true },
    component: () => import('./view/commercial/crm-reporting'),
  },

  {
    path: '/client-deliveries',
    name: 'client-deliveries',
    meta: { authRequired: true },
    component: () => import('./view/products/client-delivery'),
  },
  {
    path: '/client-delivery-create/:delivery',
    name: 'client-delivery-create',
    meta: { authRequired: true },
    component: () => import('./view/products/client-delivery-create'),
  },
  {
    path: '/client-delivery-modify/:id',
    name: 'client-delivery-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/client-delivery-create'),
  },
  {
    path: '/client-delivery/:id',
    name: 'client-delivery-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/client-delivery-detail'),
  },
  {
    path: '/deliveries',
    name: 'deliveries',
    meta: { authRequired: true },
    component: () => import('./view/products/delivery'),
  },
  {
    path: '/delivery-create/:order',
    name: 'delivery-create',
    meta: { authRequired: true },
    component: () => import('./view/products/delivery-create'),
  },

  {
    path: '/delivery-modify/:id',
    name: 'delivery-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/delivery-create'),
  },

  {
    path: '/delivery-create-product/:id',
    name: 'delivery-create-products',
    meta: { authRequired: true },
    component: () => import('./view/products/delivery-create-products'),
  },
  {
    path: '/receipt-modify/:id',
    name: 'receipt-modify',
    meta: { authRequired: true },
    component: () => import('./view/products/receipt-create'),
  },

  {
    path: '/receipt-create',
    name: 'receipt-create',
    meta: { authRequired: true },
    component: () => import('./view/products/receipt-create'),
  },

  {
    path: '/receipt-create/:id',
    name: 'receipt-create-products',
    meta: { authRequired: true },
    component: () => import('./view/products/receipt-create-products'),
  },

  {
    path: '/receipts',
    name: 'receipts',
    meta: { authRequired: true },
    component: () => import('./view/products/receipt'),
  },

  {
    path: '/receipt/:id',
    name: 'receipt-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/receipt-detail'),
  },
  {
    path: '/ats-dashboard',
    name: 'ats-dashboard',
    meta: { authRequired: true },
    component: () => import('./view/ats/ats-dashboard'),
  },

  {
    path: '/recruitments',
    name: 'recruitments',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitments'),
  },
  {
    path: '/ats-reports',
    name: 'ats-reports',
    meta: { authRequired: true },
    component: () => import('./view/ats/reports'),
  },
  {
    path: '/recruitment-create',
    name: 'recruitment-create',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-create'),
  },
  {
    path: '/recruitment-modify/:id',
    name: 'recruitment-modify',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-modify'),
  },
  {
    path: '/recruitment-create-form/:id',
    name: 'recruitment-create-form',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-create-form'),
  },
  {
    path: '/recruitment-modify-form/:id/:state',
    name: 'recruitment-modify-form',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-modify-form'),
  },
  {
    path: '/recruitment-create-team/:id',
    name: 'recruitment-create-team',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-create-team'),
  },
  {
    path: '/recruitment-create-pipeline/:id',
    name: 'recruitment-create-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-create-pipeline'),
  },
  {
    path: '/recruitment-modify-pipeline/:id/:state',
    name: 'recruitment-modify-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-modify-pipeline'),
  },
  {
    path: '/recruitments/:id',
    name: 'recruitment-detail',
    meta: { authRequired: true },
    component: () => import('./view/ats/recruitment-detail'),
  },
  {
    path: '/page-test',
    name: 'page-test',
    meta: { authRequired: true },
    component: () => import('./view/home/page-test'),
  },
  {
    path: '/cvtech',
    name: 'cvtech',
    meta: { authRequired: true },
    component: () => import('./view/ats/cvtech'),
  },
  {
    path: '/cvtechprofile/:id',
    name: 'cvtechprofile',
    meta: { authRequired: true },
    component: () => import('./view/ats/cvtechprofile'),
  },
  {
    path: '/delivery/:id',
    name: 'delivery-detail',
    meta: { authRequired: true },
    component: () => import('./view/products/delivery-detail'),
  },
  {
    path: '/calendar',
    name: 'calendar',
    meta: { authRequired: true },
    component: () => import('./view/calendar/calendar'),
  },

  {
    path: '/application',
    name: 'application',
    meta: { authRequired: true },
    component: () => import('./view/ats/application'),
  },

  {
    path: '/manage-deploy',
    name: 'manage-deploy',
    meta: { authRequired: true },
    component: () => import('./view/ats/manage-deploy'),
  },

  {
    path: '/career-company',
    name: 'career-company',
    meta: { authRequired: true },
    component: () => import('./view/ats/career-company'),
  },

  {
    path: '/career-exchange',
    name: 'career-exchange',
    meta: { authRequired: true },
    component: () => import('./view/ats/career-exchange'),
  },

  {
    path: '/career-tech-two',
    name: 'career-tech-two',
    meta: { authRequired: true },
    component: () => import('./view/ats/career-tech-two'),
  },

  {
    path: '/career-home/:company',
    name: 'career-home',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-home'),
  },

  {
    path: '/career-recruitment-info/:company/:id',
    name: 'career-recruitment-info',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-recruitment-info'),
  },

  {
    path: '/career-recruitments/:company',
    name: 'career-recruitments',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-recruitments'),
  },

  {
    path: '/career-team/:company',
    name: 'career-team',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-team'),
  },

  {
    path: '/career-tech/:company',
    name: 'career-tech',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-tech'),
  },

  {
    path: '/career-form/:company/:id',
    name: 'career-form',
    meta: { authRequired: false },
    component: () => import('./view/ats/carreer-site/career-form'),
  },

  {
    path: '/create-pipeline',
    name: 'create-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/ats/create-pipeline'),
  },

  {
    path: '/create-pipeline-state/:id/:name',
    name: 'create-pipeline-state',
    meta: { authRequired: true },
    component: () => import('./view/ats/create-pipeline-state'),
  },

  {
    path: '/modify-pipeline-states/:id',
    name: 'modify-pipeline-states',
    meta: { authRequired: true },
    component: () => import('./view/ats/modify-pipeline-states'),
  },

  {
    path: '/manage-pipeline',
    name: 'manage-pipeline',
    meta: { authRequired: true },
    component: () => import('./view/ats/manage-pipeline'),
  },

  {
    path: '/manage-email',
    name: 'manage-email',
    meta: { authRequired: true },
    component: () => import('./view/ats/manage-email'),
  },

  {
    path: '/employees',
    name: 'employees',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employees'),
  },

  {
    path: '/employee-create/:type',
    name: 'employee-create',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-create'),
  },
  {
    path: '/employee-edit/:id',
    name: 'employee-edit',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-create'),
  },
  {
    path: '/employee-job/:id',
    name: 'employee-job',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-job'),
  },
  {
    path: '/employee-vehicle/:id',
    name: 'employee-vehicle',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-vehicle'),
  },
  // {
  //   path: '/employee-schedule/:id',
  //   name: 'employee-schedule',
  //   meta: { authRequired: true },
  //   details: () => import('./view/human-ressources/employee-components/employee-schedule'),
  // },
  {
    path: '/employee-pay/:id',
    name: 'employee-pay',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-pay'),
  },
  {
    path: '/employee-detail/:id',
    name: 'employee-detail',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee'),
  },

  {
    path: '/employee-schedule/:id',
    name: 'employee-schedule',
    meta: { authRequired: true },
    component: () => import('./view/human-ressources/employee-components/employee-schedule'),
  },

  // Ticketing

  {
    path: '/tickets/:type',
    name: 'tickets',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/external/external-tickets'),
  },
  {
    path: '/ticket-detail/:id',
    name: 'ticket-detail',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/external/external-ticket-detail'),
  },
  {
    path: '/ticket-internal-detail/:id',
    name: 'internal-ticket-detail',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/internal/internal-ticket-detail'),
  },
  {
    path: '/create-ticket/:company/:id',
    name: 'create-ticket',
    meta: { authRequired: false },
    component: () => import('./view/ticketing/external/create-ticket'),
  },
  {
    path: '/ticket-portal',
    name: 'ticket-portal',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/internal/portal'),
  },
  {
    path: '/ticket-portal-detail/:id',
    name: 'ticket-portal-detail',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/internal/portal-ticket-detail'),
  },
  {
    path: '/tickets_internals/:type',
    name: 'tickets-internals',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/internal/internal-tickets'),
  },
  {
    path: '/tools',
    name: 'tools',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/tools/tools'),
  },
  {
    path: '/tool-detail/:id',
    name: 'tool-detail',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/tools/tool-detail'),
  },
  {
    path: '/create-tools',
    name: 'create-tools',
    meta: { authRequired: true },
    component: () => import('./view/ticketing/tools/create-tool'),
  },

  // File manager
  {
    path: '/file-manager',
    name: 'file-manager',
    meta: { authRequired: true },
    component: () => import('./view/file-manager/file-manager'),
  },

  // Compta
  {
    path: '/payments',
    name: 'accounting-payments',
    meta: { authRequired: true },
    component: () => import('./view/accounting/payments'),
  },
  {
    path: '/accounting',
    name: 'accounting-accounts',
    meta: { authRequired: true },
    component: () => import('./view/accounting/accounts'),
  },
  {
    path: '/accounting-detail/:account',
    name: 'accounting-account-lines',
    meta: { authRequired: true },
    component: () => import('./view/accounting/account-detail'),
  },
  {
    path: '/aged-scales',
    name: 'aged-scales',
    meta: { authRequired: true },
    component: () => import('./view/accounting/aged-scale'),
  },
  {
    path: '/accounting/journals/sales',
    name: 'accounting-accounts',
    meta: { authRequired: true },
    props: { isSales: true },
    component: () => import('./view/accounting/journals'),
  },
  {
    path: '/accounting/journals/purchases',
    name: 'accounting-accounts',
    meta: { authRequired: true },
    props: { isSales: false },
    component: () => import('./view/accounting/journals'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./view/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/login/authorize',
    name: 'login-authorize',
    component: () => import('./view/account/login-authorize'),
  },
  {
    path: '/change-password',
    name: 'Change password',
    component: () => import('./view/account/change-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-invitation',
    name: 'Confirm invitation',
    component: () => import('./view/account/confirm-invitation'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./view/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('authfack/logout')
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.push('/login'))
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/organization-tickets/:company/:id',
    name: 'organization-tickets',
    component: () => import('@/router/view/ticketing/external/organization-tickets.vue'),
    props: true,
    meta: { authRequired: false },
  },
]
